import { Action } from '@/_core/fluxstore/types';
import { NotificationsState } from '../types';
import { useNotificationsStore } from '../useModule';
import { useSendCommand } from '@/_core/cqrs/use';
import { DismissAllNotificationsOfUserCommand } from '@/api/notifications/commands';

const { registerMiddleware, registerReducer } = useNotificationsStore();

export class DismissAllNotificationsOfUser extends Action<NotificationsState> {
    public static ACTION_TYPE = 'DismissAllNotificationsOfUser';
    public constructor(public directMessagesOnly: boolean) {
        super(DismissAllNotificationsOfUser.ACTION_TYPE);
    }
}

const middleware = async (state: NotificationsState, action: DismissAllNotificationsOfUser): Promise<boolean> => {
    return await useSendCommand(action, {
        createCommand: () => new DismissAllNotificationsOfUserCommand(action.directMessagesOnly),
    });
};

const reducer = (state: NotificationsState, action: DismissAllNotificationsOfUser): void => {
    const toDismiss = action.directMessagesOnly ? state.allNotifications.filter((x) => x.isDirectMessage.value) : state.allNotifications;

    toDismiss.forEach((item) => (item.isDismissed = true));
};

//@ts-ignore
registerMiddleware(DismissAllNotificationsOfUser.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(DismissAllNotificationsOfUser.ACTION_TYPE, reducer);
